import { Divider, Grid } from '@mui/material';
import { grey } from '@mui/material/colors';
import { map } from 'lodash';
import React, { useState } from 'react';

import CommentContent from './CommentContent';
import CommentReply from './CommentReply';
import NewComment from './NewComment';

import { type TaskComment, type CommentReaction } from '@/graphql/generated/graphql';

interface ShowCommentProps {
  comment: TaskComment;
  taskId: string;
  index: number;
}

const ShowComment: React.FC<ShowCommentProps> = ({ comment, taskId, index }) => {
  const [selectedComment, setSelectedComment] = useState<TaskComment | null>(null);
  const [parentCommentId, setParentCommentId] = useState<string | null>(null);

  const getReactorsInfo = (reaction: CommentReaction) => {
    return (
      <Grid container flexDirection="column" spacing={1}>
        {map(reaction.employments, (employment, index) => (
          <span key={index}>
            {employment.employee?.firstName} {employment.employee?.lastName}
          </span>
        ))}
      </Grid>
    );
  };

  const handleReplyClick = () => setParentCommentId(comment.id);
  const handleEditClick = () => setSelectedComment(comment);

  return (
    <React.Fragment key={`comment-${comment.id}-${index}`}>
      {selectedComment ? (
        <NewComment taskId={taskId} selectedComment={selectedComment} setSelectedComment={setSelectedComment} />
      ) : (
        <>
          <CommentContent
            comment={comment}
            onReplyClick={handleReplyClick}
            onEditClick={handleEditClick}
            getReactorsInfo={getReactorsInfo}
          />

          {/* Replies */}
          <Grid
            sx={{
              borderLeft: `1px solid ${grey[400]}`,
              ml: 5,
            }}
          >
            {map(comment.replies || [], (reply, replyIndex) => (
              <CommentReply
                key={`reply-${replyIndex}-${reply.id}`}
                comment={reply}
                index={replyIndex}
                taskId={taskId}
                setMainCommentId={() => setParentCommentId(comment.id)}
                getReactorsInfo={getReactorsInfo}
              />
            ))}
          </Grid>

          {/* Reply Form */}
          {parentCommentId && (
            <NewComment taskId={taskId} parentCommentId={parentCommentId} setParentCommentId={setParentCommentId} />
          )}
        </>
      )}
      <Divider sx={{ mb: 2, mt: 2 }} />
    </React.Fragment>
  );
};

export default ShowComment;
